export default "__VITE_PUBLIC_ASSET__888facc8__"